// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__Pa-32","notes":"Notes_notes__QNevY","note":"Notes_note__1kOqz","markdown":"Notes_markdown__2xNRH"};